import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn:'root'
})
export class globalService{
    shaToken="";
    userData;
    loginMode='production';
    private defaultLang="de";

    constructor(private translate: TranslateService){}

    get lang() {
        return this.defaultLang;
    }

    setLang(lang="de") {
        this.defaultLang = lang;
        this.translate.use(this.defaultLang);
    }
}